/**
 * Created by Dhanya Akhil on 2/02/2017.
 */
import {Injectable} from '@angular/core';
import {PrincipalService} from './principal.service';
import {AuthServerProvider} from './auth-session.service';
import {TranslateService} from '@ngx-translate/core';
import {Router} from '@angular/router';
import {AccountResourceApi} from './api/account-resource.api';
import {ApiConfig} from './api/config.api';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {TokenService} from './token.service';

@Injectable()
export class LoginService {
  authenticationError;
  changelang;
  timedOut;
  constructor(
    private principal: PrincipalService,
    private authServerProvider: AuthServerProvider,
    public translate: TranslateService,
    public tokenService: TokenService,
    public router: Router,
    private accountResourceApi:AccountResourceApi,
    private http: HttpClient
  ) {}

  firstLoginMFA(latitude, longitude, sign, username, password) {
    const authV1url =
      ApiConfig.baseURL + "svc/eazypension-auth-service/v1/authentication";
    const headers = new HttpHeaders()
      .append("X-SIGN", sign)
      .append("X-LOCATION-LATITUDE", latitude)
      .append("X-LOCATION-LONGITUDE", longitude)
      .append("APPID", "1");
    return this.http.post(
      authV1url,
      { username: username, password: password },
      { headers: headers, observe: "response" }
    );
  }

  accountSession(token) {
    const accountSessionUrl =
      ApiConfig.baseURL + `svc/eazypension-auth-service/v1/account/session`;
    const headers = new HttpHeaders().append("Authorization", token);
    return this.http.post(accountSessionUrl, {}, { headers: headers });
  }

  requestOtp(deviceId) {
    const requestOtpUrl =
      ApiConfig.baseURL +
      "svc/eazypension-otp-service/v1/otp/request?language=en_us&channel=web&type=MFA_OTP";
    const headers = new HttpHeaders().append("X-Identity-Id", deviceId);
    return this.http.get(requestOtpUrl, { headers: headers });
  }

  sendOtp( otp, deviceId ) {
    const sendOtpUrl =
      ApiConfig.baseURL +
      `svc/eazypension-otp-service/v1/otp/validate?language=en_us&channel=web&otp=${otp}&type=MFA_OTP`;
    const headers = new HttpHeaders().append("X-Identity-Id", deviceId);
    return this.http.get(sendOtpUrl, { headers: headers , observe: "response"});
  }

  registerMfaDevice(token) {
    const registerDeviceUrl =
      ApiConfig.baseURL +
      `svc/eazypension-auth-service/v1/account/device/register`;
    const headers = new HttpHeaders().append("Authorization", token);
    return this.http.post(registerDeviceUrl, {}, { headers: headers });
  }


  login(credentials, callback?) {
    let cb = callback || function () {};
    return new Promise((resolve, reject) => {
      this.authServerProvider.login(credentials).subscribe(
        (data: any) => {
         this.principal.identity(true).then((account) => {
            // localStorage.setItem("account", JSON.stringify(account));
            this.tokenService.secureSave("account", account);
            resolve(data);
          });
          return cb();
        },
        (err) => {
          const timeOutFlag = false;
          this.logout(timeOutFlag);
          this.router.navigate(["login"]);
          reject(err);
          return cb(err);
        }
      );
    });
  }

  logout(timeOutFlag) {
    this.authServerProvider.logout().subscribe((data) => {
      if (timeOutFlag) {
        localStorage.removeItem("account");
        this.timedOut = true;
        this.router.navigate(["login"]);
        //document.documentElement.className.replace(/\bhideClass\b/,'');
        var timeOutClass = document.getElementById("sessionTimeoutModal");
        this.removeClass(timeOutClass, "hideClass");
        timeOutClass.className = "";
        timeOutClass.className += "showclass";
      }
      this.authenticationError = false;
      this.router.navigate(["login"]);
    });
  }
  removeClass(ele, cls) {
    if (this.hasClass(ele, cls)) {
      var reg = new RegExp("(\\s|^)" + cls + "(\\s|$)");
      ele.className = ele.className.replace(reg, " ");
    }
  }
  hasClass(ele, cls) {
    return ele.className.match(new RegExp("(\\s|^)" + cls + "(\\s|$)"));
  }
}
